import { BaseAPI } from "../base/service";
import { Auth } from "../auth/dto"

export class MeApi extends BaseAPI {
    public async getInfoUser(): Promise<Auth> {
        return await this.api.get('/me/');
    }
}